import React from "react";

export interface WrapperProps {
  children: React.ReactNode;
  headerLayout?: JSX.Element | React.ReactNode;
}
export function WrapperLayout(props: WrapperProps) {
  return (
    <main style={{ flex: 1, overflow: "hidden", width: "100", height:"100%", margin: 0, padding: 0 }}>
      <div>
        {props?.headerLayout}
        {props.children}
      </div>
    </main>
  );
}
export default React.memo(WrapperLayout);
